import {Alert, Button, H1, HBox, Input, Light, Main, VBox} from '@bakkt/components'
import {useStore} from 'store'
import React, {useEffect, useState} from 'react'
import Page from '../../../../components/Page'
import {embeddedPartnerApi} from '../../../../api'
import {cleanEmail} from '../../../../validate'
import {RoutesName} from '../../../../constants/routes'
import {useNavigate} from 'react-router-dom'
import {useUserId} from '../../../../hooks/auth/useUserId'

const EditAccountEmail = () => {
	const [newEmail, setNewEmail] = useState('')
	const {lastError, setIdentifier, setUserIdentity, partyProfile, setRedirectUrlAfterOtpValidation} = useStore()
	const [errorMessage, setErrorMessage] = useState('')
	const [isValidIdentifier, setIsValidIdentifier] = useState(true)
	const {isMobileNumber: isEmail, isValid: isNewEmailValid, error: newEmailError} = useUserId(newEmail)
	const navigate = useNavigate()

	useEffect(() => {
		setNewEmail(partyProfile?.Party?.email!)
	}, [partyProfile])

	const validateIdentifier = () => {
		if (isNewEmailValid && newEmail !== partyProfile?.Party?.email) {
			return false
		}
		return true
	}

	const updateIdentifier = async () => {
		if (newEmail !== partyProfile?.Party?.email) {
			const response = await embeddedPartnerApi.updateIdentifier({
				identifier: {
					email: cleanEmail(newEmail),
				},
			})
			if (response?.data?.success) {
				setIdentifier(response.data.payload)
				setUserIdentity(cleanEmail(newEmail))
				setRedirectUrlAfterOtpValidation(RoutesName.home)
				navigate(`/${RoutesName.auth.verifyOtp}`)
			} else if (response?.data.error?.code === 'INVALID_FIELD_VALUE') {
				setIsValidIdentifier(false)
				setErrorMessage(response?.data.error?.message!)
			} else {
				navigate(`/${RoutesName.auth.verifyOtp}`)
			}
		}
	}

	return (
		<Page withBackIcon loading={!partyProfile?.Party && !lastError}>
			{!isValidIdentifier && (
				<Alert
					severity='error'
					icon={false}
					onClose={() => setIsValidIdentifier(true)}
					data-testid='update-identifier-error-alert'
				>
					{errorMessage}
				</Alert>
			)}
			<Main>
				<VBox verticalGap={15}>
					<HBox style={{paddingLeft: '10px'}}>
						<H1>Edit Profile</H1>
					</HBox>
				</VBox>
				<HBox style={{paddingLeft: '15px'}}>
					<Light>Enter your new email address</Light>
				</HBox>
				<VBox verticalGap={15}>
					<Input
						type={'text'}
						label='Email'
						value={partyProfile?.Party?.email}
						disableClose={true}
						helperText={newEmailError}
						error={!!newEmailError}
						onChange={(_, value) => setNewEmail(value)}
					/>
				</VBox>

				<HBox style={{marginTop: 50, justifyContent: 'center'}}>
					<div style={{width: '91%', textAlign: 'center'}}>
						<Button
							size={'large'}
							fullWidth={true}
							disabled={validateIdentifier()}
							onClick={updateIdentifier}
						>
							Continue
						</Button>
					</div>
					)
				</HBox>
			</Main>
		</Page>
	)
}

export default EditAccountEmail
